import React, { useEffect, useState } from 'react';
import { ToggleWrapper } from './toggle.styled';
import { ToggleClosed } from './toggle-closed';
import { ToggleOpened } from './toggle-opened';
import { ToggleLoading } from './toggle-loading';
import { useUserContext } from '../../contexts/user';
import { useToggleContext } from '../../contexts/toggle';
import { useEngagementContext } from '../../contexts/engagement';
import { useMsgContext, useNewMsgContext } from '../../contexts/msg';
import { stage } from '../../axp/sdk';
import useConfig from '../../hooks/config.hook';
import { useOmniPageContext } from '../../contexts/omnipage';
import useSessionStorage from '../../hooks/sessionStorage.hook';
import { useSDKContext } from '../../contexts/sdk';
import { UserDefaultType } from '../../models/user';

let count = 0;

function Toggle() {
   const user = useUserContext();
   const toggle = useToggleContext();
   const engagementCtxt = useEngagementContext();
   const SDKCtxt =  useSDKContext();
   const config = useConfig()
   
   const activeEngagement = useSessionStorage("ccaasActiveEngagements")
   const OmniPageCtxt = useOmniPageContext();
   const msgContext = useMsgContext();
   const [block, setBlock] = useState(false)
   useEffect(() => {
      if (engagementCtxt?.engagementStatus?.closed) {
         setBlock(true)
         shutdown().then(() => {
            engagementCtxt.resetEngagement()
            console.debug("shutting down")
         }).finally(() => {
            setBlock(false)
         })
      }
   }, [engagementCtxt?.engagementStatus?.closed])

   async function onClick() {
      if (!toggle) throw new Error('No toggle context');
      if (!block) {
         toggle.onClick();
      }
   }
   useEffect(()=>{
      if(engagementCtxt?.isActive() && !engagementCtxt?.isConnected() && !engagementCtxt?.isHistory()){ 
         restart()
      }
   }, [])

   useEffect(() => {
      if (toggle?.isOpen) {
         if (engagementCtxt?.isActive() || engagementCtxt?.isHistory()) {
            minimize()
         }
         else {
            init();
         }
      }
   }, [toggle?.isOpen])


   async function restart() {
      await SDKCtxt?.restartSDK(user?.getUserInfo() as UserDefaultType, config, true)
   }

   function minimize() {
      console.debug("Minimizing chat widget")
      console.debug(msgContext)
   }


   
   async function shutdown(): Promise<void> {
     
      await SDKCtxt?.shutdownSDK();
   }

   async function init(): Promise<void> {

         await SDKCtxt?.initializeSDK(user?.getUserInfo() as UserDefaultType, config, false);
      // }
   }
   function getToggle() {
      if (!block) {
         if (toggle?.isOpen) {
            return (<ToggleOpened />)
         }
         else if (!toggle?.isOpen) {
            return (<ToggleClosed />)
         }
      } else {
         return (<ToggleLoading />)
      }

   }
   return (
      <ToggleWrapper>
         <button onClick={onClick}>
            {getToggle()}
         </button>
      </ToggleWrapper>
   )
}

export default Toggle;
